import * as logData from "./log";

export default {
  logData
};
